export const AFTER_7PM_VALUE = 'after_7pm'
export const PHARMACY_SERVICE_LIST: Array<PharmacyService> = [
  {
    value: 'credit_card',
    label: 'クレジットカード',
    category: 'payment',
  },
  {
    value: 'barcode',
    label: 'バーコード決済',
    category: 'payment',
  },
  {
    value: 'transportation_electronic_money',
    label: '交通系電子マネー',
    category: 'payment',
  },
  {
    value: 'debit_card',
    label: 'デビットカード',
    category: 'payment',
  },
  {
    value: 'parking',
    label: '駐車場あり',
    category: 'facility',
  },
  {
    value: 'drugstore',
    label: 'ドラッグストア併設',
    category: 'facility',
  },
  {
    value: 'barrier_free',
    label: 'バリアフリー',
    category: 'facility',
  },
  {
    value: 'kids_space',
    label: 'キッズスペース',
    category: 'facility',
  },
  {
    value: 'herbal_medicine',
    label: '漢方薬',
    category: 'medicine_information',
  },
  {
    value: 'single_packaged',
    label: '一包化',
    category: 'medicine_information',
  },
  {
    value: 'narcotic_prescription',
    label: '麻薬処方箋',
    category: 'medicine_information',
  },
  {
    value: 'handicap_accessible',
    label: '障害者対応',
    category: 'other',
  },
  {
    value: 'multilingual',
    label: '多言語対応',
    category: 'other',
  },
  {
    value: 'my_number',
    label: 'マイナ保険証可',
    category: 'other',
  },
  {
    value: 'electronic_prescription',
    label: '電子処方箋可',
    category: 'other',
  },
]

type ServiceCategory = 'facility' | 'payment' | 'medicine_information' | 'other'

export type PharmacyService = {
  category: ServiceCategory
  label: string
  value: string
}
